import React, { useState, useEffect } from 'react';
import { Grid, IconButton, Stack, Tooltip, Box, Typography } from '@mui/material';
import '../../../assets/scss/autoComplete.scss';
import format from 'date-fns/format';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { getUsersList } from '../../../redux/slice/usersListSlice';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid, GridToolbarContainer } from '@mui/x-data-grid';
import Switch from './switch';
import SwitchStatusDialog from './switchStatusDialog';
import ROUTES from '../../../utils/routes';
import { ROLES } from '../../../utils/config';
import { updateUserData } from '../../../redux/slice/manageUserSlice';
import { CommonButton } from '../../../Components/common/commonButton';
import { CommonPaginationContainer, CommonSelect, CommonFilterSidebar } from '../../../Components/common';
import VisibilityIcon from "@mui/icons-material/Visibility";
import FilterListIcon from "@mui/icons-material/FilterList";
import instance from "../../../redux/api";
import { exportUsers, getPaginatedUsers } from '../../../Services/api';
import { useStyles } from '../../../Components/bankTransactions/bankTranscationContainerStyles';
import { commonToast } from '../../../Components/common';
import { customDateFormat } from "../../../Components/CashAllocation/utils";
import EditNoteIcon from '@mui/icons-material/EditNote';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import '../../../Components/common/commonPageStyles.css';

const userListaddUser = {
  color: 'white',
  backgroundColor: '#1672DE',
  borderRadius: '10px',
  padding: '10px 24px',
  fontWeight: '600',
  fontSize: '14px',
  textTransform: 'none',
  minHeight: '40px',
  minWidth: '120px',
  boxShadow: '0 2px 8px rgba(22, 114, 222, 0.2)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: '#1565c0',
    boxShadow: '0 4px 12px rgba(22, 114, 222, 0.3)',
    transform: 'translateY(-1px)',
  },
  '&:active': {
    transform: 'translateY(0)',
  },
  '&:disabled': {
    backgroundColor: '#CCCCCC',
    color: '#ffffff',
    boxShadow: 'none',
    cursor: 'not-allowed',
  },
};


const UserList = () => {
  const { usersList } = useSelector((state) => state?.usersList);
  const { userData } = useSelector((state) => state?.user);
  const isUserListLoading = useSelector(
    (state) => state?.usersList?.isUserListLoading
  );
  const toggle = useSelector((state) => state.toggleSideMenu);
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
  };

  const [formdata, setFormData] = useState({
    name: "",
    startdate: "",
    enddate: "",
    status: "",
    role: "",
    email: "",
  });

  const [switchDialog, setSwitchDialog] = useState({
    id: "",
    status: "",
    isOpen: false,
  });
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [isAuditOpen, setIsAuditOpen] = useState(false);
  const classes = useStyles();

  /*
  // Trigger search logic whenever form data changes
  useEffect(() => {
    handleSubmitSearch();
  }, [formdata, usersList]);
  */

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUsersList());
  }, []);

  const userManagement =
    userData?.user_permissions?.permissions_list["User Management"] ?? {};

  const displayActionsColumn =
    userManagement?.Add?.toUpperCase() === "Y" ||
    userManagement?.Edit?.toUpperCase() === "Y" ||
    userManagement?.View?.toUpperCase() === "Y" ||
    userManagement?.["In-Active"]?.toUpperCase() === "Y";

  /*
  const handleSubmitSearch = async () => {
    setsearchResult([]);
    var newSearchArr = [];
    if (formdata.name && formdata.role && formdata.status) {
      usersList.find((opt) => {
        if (
          opt.user_name &&
          opt.user_name.toLowerCase()?.includes(formdata.name?.toLowerCase()) &&
          opt.role &&
          formdata.role === opt.role &&
          opt.status &&
          formdata.status === opt.status
        ) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.name && formdata.role) {
      usersList.find((opt) => {
        if (
          opt.user_name &&
          opt.user_name.toLowerCase()?.includes(formdata.name?.toLowerCase()) &&
          opt.role &&
          formdata.role === opt.role
        ) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.name && formdata.status) {
      usersList.find((opt) => {
        if (
          opt.user_name &&
          opt.user_name.toLowerCase()?.includes(formdata.name?.toLowerCase()) &&
          formdata.status === opt.status
        ) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.role && formdata.status) {
      usersList.find((opt) => {
        if (
          opt.role &&
          formdata.role === opt.role &&
          formdata.status === opt.status
        ) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.name) {
      usersList.find((opt) => {
        if (
          opt.user_name &&
          opt.user_name.toLowerCase()?.includes(formdata.name?.toLowerCase())
        ) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.role) {
      usersList.find((opt) => {
        if (opt.role && formdata.role === opt.role) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else if (formdata.status) {
      usersList.find((opt) => {
        if (formdata.status === opt.status) {
          newSearchArr.push(opt);
        }
      });
      if (newSearchArr.length === 0) {
        // setnoSearchResultData(true);
      }
    } else {
      // setnoSearchResultData(false);
    }
     setsearchResult(newSearchArr);
    // setnoSearchResultData(newSearchArr.length === 0);
  };
  */

  // Calculate the starting and ending indices for the current page
  // const startIndex = page * rowsPerPage;
  // const endIndex = Math.min(startIndex + rowsPerPage, usersList.length);
  // const paginatedData = usersList?.slice(startIndex, endIndex);

  const navigate = useNavigate();

  //For pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  useEffect(() => {
    if (pageState?.total >= 5) {
      setPaginationCount(Math.floor(pageState.total / pageState?.pageSize));
    } else setPaginationCount(0);
  }, [pageState.total]);

  useEffect(() => {
    if (!isClearPerformed) {
      loadData();
    }
  }, [pageState?.pageSize, pageState?.page]);

  useEffect(() => {
    if (isClearPerformed) {
      loadData();
      setIsClearPerformed(false);
    }
  }, [isClearPerformed]);

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));
      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;

      if (isSearchPerformed) {
        const { name, role, status } = formdata;
        if (name) {
          queryParams = `${queryParams}&userName=${name}`;
        }
        if (role) {
          queryParams = `${queryParams}&userRole=${role}`;
        }
        if (status) {
          queryParams = `${queryParams}&userStatus=${status}`;
        }
      }
      const response = await instance.get(
        `${getPaginatedUsers}?${queryParams}`
      );
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  const handleInputFieldChange = (name, value) => {
    setFormData({
      ...formdata,
      [name]: value ?? ""
    });
    if (isSearchPerformed && !value) {
      const searchFields = formdata;
      delete searchFields[name];
      if (Object.values(searchFields).every(value => !value)) {
        handleClearSearchList();
      }
    }
  };

  const handleSearchUserList = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const { name, role, status } = formdata;
      if (name) {
        queryParams = `${queryParams}&userName=${name}`;
      }

      if (role) {
        queryParams = `${queryParams}&userRole=${role}`;
      }
      if (status) {
        queryParams = `${queryParams}&userStatus=${status}`
      }

      setPageState((old) => ({
        ...old,
        isLoading: true
      }));

      const response = await instance.get(`${getPaginatedUsers}${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ? response?.data?.data : [],
          page: 1
        }));
        setIsSearchPerformed(true);
        setPaginationCount(Math.floor(response?.data?.count / pageState?.pageSize));
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count ?? 0,
          data: [],
        }));
        setPaginationCount(0);
      }

    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: true
      }));
      console.log("err", err);
    }
  };

  const handleClearSearchList = () => {
    setIsSearchPerformed(false);
    setFormData({
      ...formdata,
      name: "",
      role: "",
      status: ""
    })
    setPageState((old) => ({
      ...old,
      page: 1
    }));
    setIsClearPerformed(true);
  }

  const isFilterBtnDisable = () => {
    let disabled = true;
    const { name, role, status } = formdata;
    if (name !== "" || role !== "" || status !== "") {
      disabled = false;
    }
    return disabled;
  }

  const handleExportBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${exportUsers}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `Users_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Users data has been exported successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Users data could not be exported");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Users data could not be exported");
    }
  }

  const handleAddBtnClick = () => {
    navigate(ROUTES.AUMAU);
  };

  const handleDecryptClick = async (id, type, record_id = null) => {
    try {
      const response = await instance.post(`/users/user-data-decryption/`, { id, type, record_id });
      if (response.status !== 200) return;
  
      const decryptedValue = response.data;
  
      // --- Case 1: Update a specific record inside currentRow ---
      if (record_id) {
        const keyToUpdate =
          type === "new_email_value" ? "new_value" : "old_value";
        const valueToUpdate =
          type === "new_email_value"
            ? decryptedValue.new_email_value
            : decryptedValue.old_email_value;
  
        const updatedUserAuditData = currentRow?.user_audit_data?.map((audit) =>
          record_id === audit.id ? { ...audit, [keyToUpdate]: valueToUpdate } : audit
        );
  
        setCurrentRow((prev) => ({
          ...prev,
          user_audit_data: updatedUserAuditData,
        }));
  
        return;
      }
  
      // --- Case 2: Update user list ---
      // Update only the currently visible paginated data by id
      setPageState((old) => ({
        ...old,
        data: (old?.data ?? []).map((row) =>
          row?.id === id
            ? { ...row, decrypted_email: decryptedValue?.decrypted_email }
            : row
        ),
      }));
  
    } catch (error) {
      console.error("Failed to decrypt:", error);
    }
  };  

  const [currentRow, setCurrentRow] = useState("");
  const handleActionButton = (currentRowData) => {
    setCurrentRow(currentRowData);
    setIsAuditOpen(true);
  };

  let columns = [
    {
      field: "user_name",
      headerName: "User Name",
      headerAlign: "center",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "decrypted_email",
      headerName: "Email",
      headerAlign: "center",
      minWidth: 200,
      flex: 1.5,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <Typography 
            sx={{ 
              overflow: 'hidden', 
              textOverflow: 'ellipsis', 
              whiteSpace: 'nowrap',
              flex: 1,
              fontSize: '13px'
            }}
          >
            {params.value}
          </Typography>
          {userData?.role?.toLowerCase() === "manager" && (
            <IconButton
              onClick={() => handleDecryptClick(params.id, 'decrypted_email')}
              size="small"
              sx={{
                color: "#1672DE",
                padding: "4px",
                width: "28px",
                height: "28px",
                borderRadius: "6px",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                backgroundColor: "rgba(22, 114, 222, 0.08)",
                border: "1px solid rgba(22, 114, 222, 0.15)",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.12)",
                  transform: "translateY(-1px)",
                  boxShadow: "0 2px 8px rgba(22, 114, 222, 0.25)",
                  borderColor: "rgba(22, 114, 222, 0.25)",
                },
                "&:active": {
                  transform: "translateY(0)",
                },
              }}
              title="View Email"
            >
              <VisibilityIcon sx={{ fontSize: "16px" }} />
            </IconButton>
          )}
        </Box>
      ),
    },
    {
      field: "division",
      headerName: "Division",
      headerAlign: "center",
      minWidth: 100,
      flex: 1,
      valueGetter: ({ row }) => row?.division?.entity_divisions,
    },
    {
      field: "role",
      headerName: "Role",
      headerAlign: "center",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "reporting_manager",
      headerName: "Reporting Manager",
      headerAlign: "center",
      minWidth: 150,
      flex: 1,
      valueGetter: ({ row }) => row?.reporting_manager?.user_name,
    },
    {
      field: "user_start_date",
      headerName: "User Start Date",
      headerAlign: "center",
      minWidth: 120,
      flex: 1,
      valueGetter: ({ row }) =>
        row?.user_start_date
          ? customDateFormat(row?.user_start_date)
          : "",
    },
    {
      field: "user_end_date",
      headerName: "User End Date",
      headerAlign: "center",
      minWidth: 120,
      flex: 1,
      valueGetter: ({ row }) =>
        row?.user_end_date
          ? customDateFormat(row?.user_end_date)
          : "",
    },
    {
      field: "department",
      headerName: "Department",
      headerAlign: "center",
      minWidth: 150,
      flex: 1,
    },
  ];

  if (displayActionsColumn) {
    columns.push({
      field: "actions",
      headerAlign: "center",
      minWidth: 200,
      flex: 1,
      headerName: "Actions",
      sortable: false,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {userManagement?.View?.toUpperCase() === "Y" && (
              <Tooltip title="View">
                <IconButton
                  onClick={() => {
                    navigate(ROUTES.AUMVU);
                    dispatch(updateUserData(params.row));
                  }}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <VisibilityIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}

            {userManagement?.Edit?.toUpperCase() === "Y" && (
              <Tooltip title="Edit">
                <IconButton
                  onClick={() => {
                    navigate(ROUTES.AUMEU);
                    dispatch(updateUserData(params.row));
                  }}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <EditNoteIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}

            {userManagement?.["In-Active"]?.toUpperCase() === "Y" && (
              <Box
                onClick={() =>
                  setSwitchDialog({
                    id: params.row?.id,
                    status: params.row?.status,
                    isOpen: true,
                  })
                }
                sx={{
                  padding: "2px",
                  borderRadius: "6px",
                  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                  backgroundColor: "rgba(22, 114, 222, 0.08)",
                  border: "1px solid rgba(22, 114, 222, 0.15)",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.12)",
                    transform: "translateY(-1px)",
                    boxShadow: "0 2px 8px rgba(22, 114, 222, 0.25)",
                    borderColor: "rgba(22, 114, 222, 0.25)",
                  },
                  "&:active": {
                    transform: "translateY(0)",
                  },
                }}
                title="Toggle Status"
              >
                <Switch
                  key={params.row?.id}
                  {...params.row}
                  inputProps={{ "aria-label": "User Status" }}
                  checked={
                    params.row?.status === "Active" || params.row?.status === "Activate"
                  }
                />
              </Box>
            )}

            {userManagement?.Edit?.toUpperCase() === "Y" && (
              <Tooltip title="Audit Trail">
                <IconButton
                  onClick={() => handleActionButton(params.row)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <EditNoteIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    });
  }


  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchUserList();
    }
  };
  
  const handleCloseDialogs = () => {
    setIsAuditOpen(false);
  };

  return (
    <div style={Container}>
      {/* Filter Sidebar */}
      <CommonFilterSidebar
        isOpen={filterSidebarOpen}
        filterConfigs={[
          {
            type: "textInput",
            label: "Name",
            placeholder: "Search by name",
            value: formdata?.name,
            onChange: (value) => handleInputFieldChange("name", value),
            onKeyUp: handleEnter,
          },
          {
            type: "custom",
            content: (
              <>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#000",
                    marginBottom: "12px",
                  }}
                >
                  Role
                </Typography>
                <CommonSelect
                  name="role"
                  value={formdata?.role}
                  placeholder="Select Role"
                  handleChange={(event, value, reason) =>
                    handleInputFieldChange("role", value)
                  }
                  options={ROLES}
                />
              </>
            ),
          },
          {
            type: "custom",
            content: (
              <>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#000",
                    marginBottom: "12px",
                  }}
                >
                  Status
                </Typography>
                <CommonSelect
                  name="status"
                  value={formdata?.status}
                  placeholder="Select Status"
                  handleChange={(event, value, reason) =>
                    handleInputFieldChange("status", value)
                  }
                  options={["Active", "Inactive"]}
                />
              </>
            ),
          },
        ]}
        onApplyFilters={handleSearchUserList}
        onClearFilters={handleClearSearchList}
        isLoading={pageState?.isLoading}
        isFilterDisabled={isFilterBtnDisable()}
      />

      {/* Main Content Area */}
      <Box className="main-content-area">
        <Box className="page-header-container">
          <Typography variant="h5" className="page-heading">
            Users List
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {userManagement?.Add?.toUpperCase() === "Y" && (
              <>
                <CommonButton
                  text="Add User"
                  handleClick={handleAddBtnClick}
                  sx={userListaddUser}
                  hoverColor="#1565c0"
                />
                <CommonButton
                  text="Export Users"
                  handleClick={handleExportBtnClick}
                  sx={userListaddUser}
                  hoverColor="#1565c0"
                  disabled={isDownloadInProgress}
                />
              </>
            )}
            <IconButton
              onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
              className="filter-toggle-button"
            >
              <FilterListIcon />
            </IconButton>
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            position: "relative",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            overflow: "visible",
            transition: "all 0.3s ease",
            border: "1px solid #e8eaf0",
            paddingBottom: "10px",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            },
          }}
        >
          <DataGrid
            className={classes.pagination}
            loading={pageState?.isLoading}
            rows={pageState?.data ?? []}
            columns={columns}
            rowCount={pageState?.total}
            keepNonExistentRowsSelected
            disableSelectionOnClick
            pagination
            paginationMode="server"
            getRowId={(row) => row?.id}
            page={pageState.page - 1}
            pageSize={pageState?.pageSize ?? 25}
            pageSizeOptions
            rowsPerPageOptions={[10, 25, 50, 100]}
            onPageSizeChange={(newPageSize) => {
              return setPageState((old) => {
                setPaginationCount(Math.floor(pageState.total / newPageSize));
                return { ...old, pageSize: newPageSize, page: 1 };
              });
            }}
            components={{
              Toolbar: GridToolbarContainer,
              NoRowsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  No User
                </Stack>
              ),
            }}
            sx={{
              border: "none",
              flex: 1,
              minHeight: 0,
              "& .MuiDataGrid-root": {
                border: "none",
                height: "100%",
              },
              "& .MuiDataGrid-main": {
                height: "100%",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8f9fa",
                borderBottom: "2px solid #e0e0e0",
                minHeight: "52px !important",
                maxHeight: "52px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "transparent",
                fontWeight: "600",
                color: "#1672DE",
                fontSize: "14px",
                padding: "12px 16px",
                borderBottom: "none",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "600",
                  fontSize: "14px",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "#1672DE",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "#1672DE",
                },
              },
              "& .MuiDataGrid-row": {
                transition: "all 0.2s ease",
                borderBottom: "1px solid #f0f0f0",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.04)",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                },
                "&.Mui-selected": {
                  backgroundColor: "rgba(22, 114, 222, 0.08)",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.12)",
                  },
                },
                "&:nth-of-type(even)": {
                  backgroundColor: "#fafafa",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04)",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #f0f0f0",
                padding: "12px 16px",
                fontSize: "13px",
                color: "#333",
                display: "flex",
                alignItems: "center",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-columnHeader[data-field='actions']": {
                minWidth: toggle?.isOpen ? "260px !important" : "303px !important"
              },
              "& .MuiDataGrid-virtualScroller": {
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "2px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                minHeight: "48px",
                maxHeight: "48px",
                paddingBottom: "8px",
                paddingTop: "8px",
                paddingLeft: "16px",
                paddingRight: "16px",
                position: "relative",
                zIndex: 1,
                "& .MuiTablePagination-root": {
                  color: "#666",
                  paddingRight: "16px",
                  margin: 0,
                  minHeight: "32px",
                },
                "& .MuiTablePagination-selectLabel": {
                  fontSize: "13px",
                  margin: 0,
                },
              },
            }}
          />
          <Stack
            style={{
              position: "absolute",
              bottom: "8px",
              right: "16px",
            }}
          >
            <CommonPaginationContainer
              count={paginationCount + 1}
              pageState={pageState}
              setPageState={setPageState}
            />
          </Stack>
        </Box>
      </Box>

      <SwitchStatusDialog
        {...switchDialog}
        setSwitchDialog={setSwitchDialog}
        onSuccess={(updatedId, updatedStatus) => {
          // Update only currently paginated data by id so filtering/pagination stays consistent
          setPageState((old) => ({
            ...old,
            data: (old?.data ?? []).map((row) =>
              row?.id === updatedId ? { ...row, status: updatedStatus } : row
            ),
          }));
        }}
      />

      {/* User Audit model */}
      {isAuditOpen && (
        <Dialog 
          open={isAuditOpen} 
          onClose={handleCloseDialogs} 
          maxWidth='lg'
          fullWidth
          sx={{ width: "100%", height: "80vh", marginTop: "5%" }}
        >
          <DialogTitle sx={{fontSize: "1.5rem"}}>Audit Trail</DialogTitle>
          <DialogContent sx={{ overflow: "hidden", height: "70vh" }}>
            <Grid container spacing={2} mt={2} paddingLeft={2}>
              <Grid item xs={12}>
                <div style={{height: "50vh", overflowY: "auto"}}>
                  <table style={{width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f5f5f5' }}>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed Field</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Old Value</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>New Value</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed By</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Last Edit Time</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRow && currentRow?.user_audit_data?.map((audit, index) => (
                        <tr key={audit?.id}>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.field_name}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                            {audit?.old_value} 
                            {(audit?.field_name==='email') && userData?.role?.toLowerCase() === "manager" && (
                              <IconButton
                                onClick={() => handleDecryptClick(currentRow.id, 'old_email_value', audit?.id)}
                                size="small"
                              >
                                <VisibilityIcon />
                              </IconButton>
                            )}
                          </td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                            {audit?.new_value}
                            {(audit?.field_name==='email') && userData?.role?.toLowerCase() === "manager" && (
                              <IconButton
                                onClick={() => handleDecryptClick(currentRow.id, 'new_email_value', audit?.id)}
                                size="small"
                              >
                                <VisibilityIcon />
                              </IconButton>
                            )}
                          </td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.changed_by}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.current_time}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.event_type === 'add' ? 'Added bank statement' : audit?.event_type}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <CommonButton
              text="Cancel"
              handleClick={handleCloseDialogs}
              sx={{
                backgroundColor: "#ffff",
                color: "#000000",
                border: "1px solid #BCBDBF",
              }}
            />
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default UserList;
